export default __webpack_public_path__ + "static/media/19w.be25e628.svg";